import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, of } from "rxjs";
import { SessionService } from "src/app/services/session.service";
import { environment } from "src/environments/environment";
import { ILandholderConfirmationModel, ILandholderDetailsModel, INotifierDetailsModel } from "../models/veg-wizard-models";
import { Logger } from "./logger-service";

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  constructor(protected http: HttpClient,
    private sessionService: SessionService,
    private logger: Logger) {
  }

  /**
  * Updates the landholder details to api.
  * @param model the landholder details model we wish to update
  */
  setLandholderDetails$(model: ILandholderDetailsModel): Observable<boolean> {
    const sessionId = this.sessionService.getSessionId();

    const url = `${environment.apiUrl}/session/set-landholder-details`;
    model.homeAddress.countryId = 13; // Australia

    const modelForPost = { ...model, sessionKey: sessionId };
    return this.http.post(url, modelForPost)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          this.logger.error('setLandholderDetails error', err);
          return of(false)
        }),
        map(() => true) // return true, as it should be HttpStatusCode OK
      );
  }

  /**
  * Updates the notifier details to api.
  * @param model the notifier details model we wish to update
  */
  setNotifierDetails$(model: INotifierDetailsModel): Observable<boolean> {
    const sessionId = this.sessionService.getSessionId();

    const url = `${environment.apiUrl}/session/set-notifier-details`;    
    model.homeAddress.countryId = 13; // Australia

    const modelForPost = { ...model, sessionKey: sessionId };
    return this.http.post(url, modelForPost)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          this.logger.error('setLandholderDetails error', err);
          return of(false)
        }),
        map(() => true) // return true, as it should be HttpStatusCode OK
      );

  }

  setLandholderConfirmation$(model: ILandholderConfirmationModel): Observable<boolean> {
    const sessionId = this.sessionService.getSessionId();

    const url = `${environment.apiUrl}/session/set-landholder-confirmation`;

    const modelForPost = { ...model, sessionKey: sessionId };
    return this.http.post(url, modelForPost)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          this.logger.error('setLandholderConfirmation error', err);
          return of(false)
        }),
        map(() => true) // return true, as it should be HttpStatusCode OK
      );
  }
}
